import { memo, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { CREATE_ENVELOPE_WRAPPER } from "utils/constants.json";

const CreateEnvelope = ({}) => {
  const [container, setContainer] = useState(() => null);

  useEffect(
    () => setContainer(document.getElementById(CREATE_ENVELOPE_WRAPPER)),
    [],
  );

  if (!container) return null;

  return createPortal(
    <i
      title="Unterschrifsmappe erstellen"
      className="fa fa-file-signature upload-file ml-3 pointer"
      onClick={() => {
        const pathSegments = window.location.pathname.split("/");
        const number = pathSegments[pathSegments.length - 1];
        const serviceID = pathSegments[pathSegments.length - 2];
        window.open(
          `/esign-veditor/?id=new&serviceid=${serviceID}&from=${number}`,
          "_blank",
        );
      }}
    />,
    container,
  );
};

export default memo(CreateEnvelope);
